import UserProfileLink from "./UserProfileLink";

/**
 * Small avatar + @username (or business name) linking to /profile/:id.
 */
const ProfileUserLink = (props) => (
  <UserProfileLink preferUsername={true} {...props} />
);

export default ProfileUserLink;
